import styled from 'styled-components'

const VideoStyle = styled.div`
	--videoPadTop: 50%; /** //! Default size */

	&.video-cont {
		position: relative;
		width: 100%;
		padding-top: var(--videoPadTop);

		video {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			object-fit: cover;
			object-position: center;
			z-index: 1;
		}
	}

	@media (hover: hover) {
		i {
			display: none;
		}
	}

	@media (hover: none) {
		i {
			width: var(--playPauseCursorSize);
			height: var(--playPauseCursorSize);
			background-color: var(--primaryColor9);
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 6;
			opacity: 1;
			transition: all var(--trTime) ease;

			&:before {
				color: var(--bodyColor);
				font-size: var(--h4);
			}

			&.ov-pause {
				opacity: 0;
			}
		}

		&:not(.not-hover) {
			&:hover {
				.ov-pause {
					opacity: 1;
				}
			}
		}
	}
`
export default VideoStyle
